interface MobileNavProps {
    el: HTMLDivElement;
    props: {
        collapseOthers?: boolean;
        itemClass?: string;
        triggerClass?: string;
        collapsibleClass?: string;
        backTriggerClass?: string;
    };
}

const ITEM_CLASS = 'mobile-nav-item';
const TRIGGER_CLASS = 'mobile-nav-item-btn';
const COLLAPSIBLE_CLASS = 'mobile-nav-item-content-wrapper';

const MobileNav = ({ el, props }: MobileNavProps): void => {
    const {
        itemClass = ITEM_CLASS,
        triggerClass = TRIGGER_CLASS,
        collapsibleClass = COLLAPSIBLE_CLASS,
    } = props;

    const itemEls = el.querySelectorAll(`.${itemClass}`);

    // Add accordion functionality
    itemEls.forEach(itemEl => {
        const triggerEl: HTMLButtonElement | null = itemEl.querySelector(`.${triggerClass}`);
        const collapsibleEl: HTMLDivElement | null = itemEl.querySelector(`.${collapsibleClass}`);

        if (!triggerEl || !collapsibleEl) {
            return;
        }

        // set default as close if no is-open class
        if (!itemEl.classList.contains('is-open')) {
            // collapsibleEl.style.height = '0px';
            triggerEl.setAttribute('aria-expanded', 'false');
        }

        triggerEl.addEventListener('click', () => {
            if (triggerEl.classList.contains('disabled')) {
                return;
            }

            if (itemEl.classList.contains('is-open')) {
                itemEl.classList.remove('is-open');
                triggerEl.setAttribute('aria-expanded', 'false');
            } else {
                itemEl.classList.add('is-open');
                triggerEl.classList.remove('disabled');
                triggerEl.setAttribute('aria-expanded', 'true');
            }
        });
    });
};

interface CloseAllMenuMobileNavProps {
    el: HTMLDivElement;
}

export const closeAllMenuMobileNav = ({ el }: CloseAllMenuMobileNavProps): void => {
    const allIsOpenItems = el.querySelectorAll(`.is-open`);
    allIsOpenItems.forEach(itemEl => {
        const triggerEl = itemEl.querySelector(`.${TRIGGER_CLASS}`) as HTMLButtonElement | null;
        const collapsibleEl = itemEl.querySelector(`.${COLLAPSIBLE_CLASS}`) as HTMLDivElement | null;

        if (!triggerEl || !collapsibleEl) {
            return;
        }
        itemEl.classList.remove('is-open');
        el.setAttribute('aria-expanded', 'false');
        triggerEl?.setAttribute('aria-expanded', 'false');
    });
};

export default MobileNav;
